export default {
    pinChangeDecisionOption: {
        dataTrackId: 'pin-change-decision-option',
        dataTrackLinkname: `['KEEP_PIN', 'CHANGE_PIN']`,
    },
};
